import { type App } from '~/app';


export default (app: App) => {    
    app.logger.debug('[Stockland FE] Initialise Stockland Takeover Image With Inline Tabs Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            setTimeout(() =>{
                mountTakeoverImageWithInlineTabs(listeners)
            }, 300)
        })
        .catch((error: Error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Takeover Image With Inline Tabs component', error);
        });

    return function destroyFreeTextQuickLinks() {
        unMountTakeoverImageWithInlineTabs(listeners)

        app.logger.debug('[DXA] Takeover Image With Inline Tabs component destroyed');
    };


    function mountTakeoverImageWithInlineTabs(
        listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
        root: HTMLElement | null = null) {
        let rootNode: Document | HTMLElement = document;
        if (root) rootNode = root;

        const takeoverImageTabs = rootNode.querySelectorAll<HTMLElement>(".takeover-image-with-inline-tabs");
        for (const takeoverImageTab of takeoverImageTabs) {

            const amenityTabs = takeoverImageTab.querySelectorAll<HTMLElement>('.amenity-tab')

            for (const [index, tab] of amenityTabs.entries()) {
                const handleTabClick = () => {
                    const contentTabs = takeoverImageTab.querySelectorAll<HTMLElement>(`.amenity-subheading`);
                    const activeContentTab = takeoverImageTab.querySelector<HTMLElement>(`#panel-text-tab-${index}`);

                    for (const amenityTab of amenityTabs){
                        amenityTab.classList.remove('active-tab');
                    }

                    tab?.classList.add('active-tab')

                    for (const contentTab of contentTabs){
                        contentTab.classList.remove('active');
                    }

                    activeContentTab?.classList.add('active')

                }

                tab.addEventListener("show.bs.tab", handleTabClick);
                listeners.push([tab, "show.bs.tab", handleTabClick]);
            }
        }
    }


    function unMountTakeoverImageWithInlineTabs(
        listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
    ) {
        for (const [element, event, listener] of listeners) {
            element.removeEventListener(event, listener);
        }
    }
}